import Vue from 'vue';
import Child from './Child';

Vue.component(Child.name, Child);
